import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=2231c52e&scoped=true"
import script from "./Network.vue?vue&type=script&lang=js"
export * from "./Network.vue?vue&type=script&lang=js"
import style0 from "./Network.vue?vue&type=style&index=0&id=2231c52e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2231c52e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/shupian/qds-scrmnet-0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2231c52e')) {
      api.createRecord('2231c52e', component.options)
    } else {
      api.reload('2231c52e', component.options)
    }
    module.hot.accept("./Network.vue?vue&type=template&id=2231c52e&scoped=true", function () {
      api.rerender('2231c52e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Network.vue"
export default component.exports